const getCreatePaymentIntentEndpointUrl = (brandId: string, cartId: string) =>
  `/v1/brands/${brandId}/carts/${cartId}/payment_intents`;

export default getCreatePaymentIntentEndpointUrl;
